import { H3, Meta } from "@rikstv/shared-components";
import { FC, useState } from "react";
import AnimateHeight from "react-animate-height";
import {
  comparisonCategories,
  FeatureIndicatorDisplayType,
  type ComparisonCategory,
  type FeatureIndicator,
} from "~/components/routes/choose-subscription/placeholderSubscriptionComparisonData";
import { ComparableSubscription } from "~/models/subscription-comparison/ComparableSubscriptions";
import { ChevronToggleButton } from "../../button/ChevronToggleButton";
import checkmark from '../images/check.svg?url';
import { FeatureIcons } from "../images/featureIcons";
import alertTriangle from '../images/alert-triangle.svg?url';
import styles from './SubscriptionFeatures.module.css';

export const SubscriptionFeatures: FC<{subscription: ComparableSubscription, className?: string}> = ({ subscription, className }) => {
  const [showAllFeatures, setShowAllFeatures] = useState(false);
  return <div className={className}>      
    <AnimateHeight height={showAllFeatures ? 'auto' : 270}>
        <ul className={styles.features}>
          {comparisonCategories
            .filter(c => {
              const indicator = subscription.featureIndicators[c.type];
              if (!indicator) return false;
              return (
                indicator.displayType === FeatureIndicatorDisplayType.Check ||
                indicator.displayType === FeatureIndicatorDisplayType.StrongTextWithCheck ||
                c.name === 'Antall kanaler'
              );
            })
            .map((category) => (
              <SubscriptionFeature
                key={category.type}
                feature={category}
                indicator={subscription.featureIndicators[category.type]}
              />
            ))}
        </ul>
      </AnimateHeight>
    <br/>
    <ChevronToggleButton onClick={() => setShowAllFeatures(s => !s)} toggledOn={showAllFeatures} />
  </div>
}

const SubscriptionFeature: FC<{
  feature: ComparisonCategory;
  indicator: FeatureIndicator;
}> = ({ feature, indicator }) => {
  const Icon = FeatureIcons[feature.icon];
  return (
    <li key={feature.type}>
      <Icon style={{ width: '28px' }} />
      <H3 className={styles.featureName} lookLike="body">{feature.name}</H3>
      {indicator.text?.startsWith('Tilleggspakke')
      ? (<Meta style={{paddingLeft: '5ch', opacity: .8}}>{indicator.text}</Meta>)
      : (<div className={styles.indicator} style={{backgroundColor: 'transparent'}}>
          <FeatureIndicatorItem feature={indicator} />
      </div>)}
      
    </li>
  );
};

export const FeatureIndicatorItem: FC<{feature: FeatureIndicator}> = ({feature}) => {
  switch (feature.displayType) {
    case FeatureIndicatorDisplayType.Check: {
      return <img src={checkmark} alt="" aria-label={'Inkludert'} />;
    }
    case FeatureIndicatorDisplayType.Warning: {
      return <img src={alertTriangle} alt="" aria-label={'Ikke tilgjengelig'} />;
    }
    case FeatureIndicatorDisplayType.StrongText:
      return <span className="text sub-body">{feature.text}</span>;
    case FeatureIndicatorDisplayType.WeakText:
      return <span className="text sub-body subtle">{feature.text}</span>;
    case FeatureIndicatorDisplayType.StrongTextWithCheck:
      return (
        <>
          <img src={checkmark} alt="" aria-label={feature.text ?? 'Inkludert'} />
          {feature.text && <span className="text sub-body" style={{marginLeft: '8px'}}>{feature.text}</span>}
        </>
      );
  }
};